module.exports = __webpack_public_path__ + "img/art.d933ae7.jpg";